const isTruthy = (value: string | boolean | undefined): boolean => {
  if (typeof value === 'boolean') {
    return value
  }
  return value === 'true'
}

export const DEMO_LOGIN_UID = 'e2e-demo-owner'
export const DEMO_LOGIN_EMAIL = String(import.meta.env.VITE_DEMO_LOGIN_EMAIL || 'e2e-demo-owner@example.com')
export const DEMO_LOGIN_DISPLAY_NAME = String(import.meta.env.VITE_DEMO_LOGIN_DISPLAY_NAME || 'E2E 데모 사용자')
export const DEV_LOGIN_SECRET = String(import.meta.env.VITE_DEV_LOGIN_SECRET || '')

export interface DevLoginPersona {
  id: string
  email: string
  displayName: string
  projectRole: 'viewer' | 'editor' | 'owner' | 'admin'
  label: string
  description: string
}

/**
 * dev-login 페르소나 — 권한 분리 테스트용.
 * backend `INFERGRAPH_DEV_LOGIN_ALLOWED_EMAILS` 에 등록된 이메일과 매칭되어야 한다.
 * 추가 페르소나가 필요하면 backend env 와 이 배열을 같이 갱신한다.
 */
export const DEV_LOGIN_PERSONAS: DevLoginPersona[] = [
  {
    id: 'empty-user',
    email: 'empty-user@example.com',
    displayName: '신규 사용자',
    projectRole: 'editor',
    label: '빈 워크스페이스 (신규 사용자)',
    description: '본인 프로젝트 0개 — 빈 워크스페이스 흐름 검증',
  },
  {
    id: 'procurement-editor',
    email: 'p5-013r-procurement@example.com',
    displayName: '구매 담당',
    projectRole: 'editor',
    label: '구매 도메인 Editor',
    description: 'p5-013r procurement editor 권한',
  },
  {
    id: 'production-approver',
    email: 'p5-039-production-approver@example.com',
    displayName: '생산 승인자',
    projectRole: 'editor',
    label: '생산 승인자 (Approver)',
    description: 'p5-039 production approval 권한',
  },
  {
    id: 'finance-reviewer',
    email: 'finance.demo.reviewer@example.com',
    displayName: '재무 리뷰어',
    projectRole: 'viewer',
    label: '재무 Reviewer',
    description: 'finance demo reviewer (read-only)',
  },
  {
    id: 'global-admin',
    email: DEMO_LOGIN_EMAIL,
    displayName: DEMO_LOGIN_DISPLAY_NAME,
    projectRole: 'admin',
    label: 'Global Admin (모든 권한)',
    description: '모든 프로젝트 접근 가능 — 기존 E2E 호환',
  },
]

// Production builds (import.meta.env.PROD === true) MUST NEVER expose the demo / dev login flow.
// There is no escape hatch here on purpose — even if a deploy accidentally ships
// VITE_ALLOW_*_IN_PRODUCTION=true, this hard guard short-circuits before any check.
// Per CLAUDE.md "DEV MODE 인증 우회 코드 절대 금지" — dev login is a debug-only fixture.

export const isDemoLoginEnabled = (): boolean => {
  if (import.meta.env.PROD) {
    return false
  }

  const explicitFlag = import.meta.env.VITE_ENABLE_DEMO_LOGIN
  if (explicitFlag !== undefined) {
    return isTruthy(explicitFlag)
  }

  return Boolean(import.meta.env.DEV || import.meta.env.MODE === 'test')
}

export const isBackendDevLoginEnabled = (): boolean => {
  if (import.meta.env.PROD) {
    return false
  }

  return isTruthy(import.meta.env.VITE_ENABLE_DEV_LOGIN) && DEV_LOGIN_SECRET.length > 0
}
